window.addEventListener('load', () => {
  console.log('[Product Tax] Window fully loaded');

  if (!document.body.classList.contains('template-product')) {
    console.log('[Product Tax] Not a product page. Stopping.');
    return;
  }

  console.log('[Product Tax] Product page detected');

  const source = document.querySelector(
    '.price-wrapper .product__tax.caption'
  );

  const target = document.querySelector(
    '.installment-wrapper .lb-qty-selector-wrapper'
  );

  console.log('[Product Tax] Source:', source);
  console.log('[Product Tax] Target:', target);

  if (!source) {
    console.warn('[Product Tax] Source element not found');
    return;
  }

  if (!target) {
    console.warn('[Product Tax] Target element not found');
    return;
  }

  const duplicate = source.cloneNode(true);

  console.log('[Product Tax] Duplicated element:', duplicate);

  target.after(duplicate);

  console.log('[Product Tax] Successfully inserted duplicate before target');
});

document.addEventListener('DOMContentLoaded', () => {
  const injectShopifyChatStyle = () => {
    const host = document.querySelector('#ShopifyChat');
    if (host && host.shadowRoot) {
      // Prevent duplicate injection
      if (!host.shadowRoot.querySelector('style[data-chat-style]')) {
        const style = document.createElement('style');
        style.dataset.chatStyle = 'true';
        style.textContent = `
          button.chat-toggle.chat-toggle--text-button {
            border-radius: 4px;
            height: auto;
            padding-left: 10px;
            padding-right: 14px;
          }
          button.chat-toggle.chat-toggle--text-button .chat-title {
            font-size: 16px;
            font-weight: 500;
          }
          button.chat-toggle svg {
            height: 20px;
          }
          .chat-app .chat-app--close-button{
            width: 40px;
            height: 40px;
          }
          .chat-app .chat-app--close-button svg{
            width: 20px;
            height: 20px;
          }
        `;
        host.shadowRoot.appendChild(style);
        //console.log('✅ Shopify Chat custom style injected');
      }
      return true;
    }
    return false;
  };

  // Try immediately first
  if (!injectShopifyChatStyle()) {
    // If not found, observe for when Shopify Chat is added
    const observer = new MutationObserver(() => {
      if (injectShopifyChatStyle()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
function insertFooterCopyrightLink() {
  const target = document.querySelector('.footer__copyright > .copyright__content:first-child');
  if (!target) return;

  const span = document.createElement('span');
  span.className = 'copyright__content secondary_text';
  span.innerHTML = '<a href="https://plaimanas.com/" target="_blank">web by ::*</a>';

  target.insertAdjacentElement('afterend', span);
}
function setupSlideshowVideoSoundToggle() {
  document.querySelectorAll('.template-index > #MainContent > .slideshow-section:first-child .slideshow__video-wrapper').forEach(wrapper => {
    const video = wrapper.querySelector('video');
    if (!video) return;

    // Ensure video starts muted
    video.muted = true;

    // Create toggle button
    const btn = document.createElement('a');
    btn.className = 'toggleSound-btn muted';
    btn.href = 'javascript:;';

    // Insert into wrapper
    wrapper.after(btn);

    // Toggle on click
    btn.addEventListener('click', () => {
      video.muted = !video.muted;
      btn.classList.toggle('muted', video.muted);
    });
  });
}
document.addEventListener('DOMContentLoaded', function(){
  setupSlideshowVideoSoundToggle()
  insertFooterCopyrightLink();
});

document.addEventListener("DOMContentLoaded", function () {
  const contactForm = document.querySelector("#shopify-section-template--24944766419217__contact_form_Q8rAQg");
  const aboutBlocks = document.querySelectorAll(".about-us__description--block");

  if (contactForm && aboutBlocks.length > 0) {
    const lastBlock = aboutBlocks[aboutBlocks.length - 1];
    lastBlock.insertAdjacentElement("afterend", contactForm);
  }
});


const elementToMove = document.querySelector('#shopify-section-template--24944765960465__rich_text_hhLJHL');
const target = document.querySelector('.article-template__header');

if (elementToMove && target && target.parentNode) {
  target.parentNode.insertBefore(elementToMove, target);
}

const dateSpan = document.querySelector('.article-template__date .card__subtitle span');
if (dateSpan) {
  dateSpan.textContent = 'Press';
}



//single product
jQuery(document).ready(function($) {
  $('.installment-wrapper').insertAfter('#shopify-block-AdWZjSUZHTndRTFdPd__bold_subscriptions_bsub_widget_block_qrp3fQ');
  const waitForButton = setInterval(() => {
    const $btn = $('.lb-qty-selector-atc-button');
    if ($btn.length) {
      $btn.addClass('button button--tertiary focus-inset').hide();
      clearInterval(waitForButton);
    }
  }, 300);
  
  function toggleInstallmentDisplay() {
    const $installment = $('.installment-wrapper');

    if (!$installment.length) return;

    const $selected = $('input[name="bsub-selling-plan-group"]:checked');

    if (!$selected.length) return;

    if ($selected.val() === 'once') {

      $installment.show();
      $('.product-form__submit').hide();

      const waitForButton = setInterval(() => {
        const $btn = $('.lb-qty-selector-atc-button');

        if ($btn.length) {
          $btn.show();
          clearInterval(waitForButton);
        }
      }, 300);

    } else if ($selected.hasClass('bsub-widget__input')) {

      $installment.hide();
      $('.product-form__submit').show();
      $('.lb-qty-selector-atc-button').hide();

    }
  }

  toggleInstallmentDisplay();
  $(document).on('change', 'input[name="bsub-selling-plan-group"]', toggleInstallmentDisplay);

});